import React, { useState } from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Stack from "@mui/material/Stack";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";


import { addListing } from "../Firebase";

export default function ListingPopUp({ open, handleClose }) {
  //const [open, setOpen] = useState(false);
  const [name, setName] = useState("");
  const [address, setAdd] = useState("");
  const [type, setType] = useState("");
  const [food_desc, setFood] = useState("");

  function handleClick() {
    //this function adds an event for yourself too
    addListing(name, address, type, food_desc);
    clear();
    handleClose();
  }

  function clear() {
    setName("");
    setAdd("");
    setType("");
    setFood("");
  }

  function handleCancel() {
    clear();
    handleClose();
  }

  return (
    <div>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Create Food Donation Listing</DialogTitle>
        <DialogContent>
          <Stack spacing={2} style={{ paddingTop: "5px" }}>
            <TextField
              label="Name"
              required
              placeholder="UCLA Bruins Swipe Out Hunger"
              value={name}
              onChange={(e) => setName(e.target.value)}
              fullWidth
            />

            <TextField
              label="Address"
              required
              placeholder="265 De Neve Dr"
              value={address}
              onChange={(e) => setAdd(e.target.value)}
              fullWidth
            />

            <FormControl>
              <FormLabel id="demo-radio-buttons-group-label">
                Food Donor Type
              </FormLabel>
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                defaultValue="Restaurant"
                name="radio-buttons-group"
                value={type}
                onChange={(e) => setType(e.target.value)}
              >
                <FormControlLabel
                  value="Restaurant"
                  control={<Radio />}
                  label="Restaurant"
                />
                <FormControlLabel
                  value="FoodShelter"
                  control={<Radio />}
                  label="Food Shelter"
                />
              </RadioGroup>
            </FormControl>

            <TextField
              id="outlined-multiline-static"
              label="Description"
              multiline
              rows={4}
              placeholder="Mexian food every Tuesdays and Thursdays from 3-6 pm; vegetarian/vegan options available."
              value={food_desc}
              onChange={(e) => setFood(e.target.value)}
              defaultValue="Default Value"
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          <button className="button_blue_small" onClick={handleClick}>
            Create!
          </button>
          <button className="button_red_small" onClick={handleCancel}>
            Cancel
          </button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
